import { useGlobalState, useStatsigLayer } from '@/hooks';
import { LanguageCode } from '@/interfaces';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import { getTextByLanguage } from '@/modules/pmt/utils';

export const usePmtOnboardingPopupCopy = (popUp: IPmtOnboardingPopup | undefined): IPmtOnboardingPopup | undefined => {
  const { pmtCurrentLanguageCode } = useGlobalState();
  const { get, isReady } = useStatsigLayer('track_my_parcel_copy_layer');

  if (!popUp) return undefined;

  const isEnglish = pmtCurrentLanguageCode === LanguageCode.English;

  if (!isEnglish || !isReady) return popUp;

  const mergedPropositionList = popUp.joinUsValuePropositionList?.map((item, index) => {
    const i = index + 1;
    return {
      ...item,
      title: get(`proposition_${i}_title`, getTextByLanguage(item.title ?? '', 'en')),
      description: get(`proposition_${i}_description`, getTextByLanguage(item.description ?? '', 'en')),
    };
  });

  return {
    ...popUp,
    joinUsHeader: get('join_us_header', popUp.joinUsHeader),
    joinUsValuePropositionList: mergedPropositionList ?? popUp.joinUsValuePropositionList,
    joinUsDesktopMainText: get('join_us_main_text', popUp.joinUsDesktopMainText),
    joinUsSubtext: get('join_us_subtext', popUp.joinUsSubtext),
    subPmcNewsletterText: get('newsletter_checkbox_label', popUp.subPmcNewsletterText),
    newsletterSubText: get('newsletter_subtext', popUp.newsletterSubText),
  };
};
